import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  ConfirmationModalComponent, type ConfirmationModalProps,
} from './confirmationModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    Confirmation: ConfirmationModalProps;
  }
}
modalRenderer.register('Confirmation', ConfirmationModalComponent);
